// =============================================
// ArchetypeIcon — symbolic SVG illustrations
// matching the CTFD archetype visual system
// (charcoal linework + restrained burnt-orange accents)
// =============================================

const STROKE = '#1A1A1A';
const ACCENT = '#E8590C';
const NEUTRAL = '#9E9E9E';

function GroundedOperator() {
  return (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Outer orbit */}
      <ellipse cx="100" cy="100" rx="78" ry="56" stroke={STROKE} strokeWidth="1.2" />
      {/* Inner orbit */}
      <ellipse cx="100" cy="100" rx="60" ry="42" stroke={STROKE} strokeWidth="1" strokeDasharray="2 3" />
      {/* Cross-hairs */}
      <line x1="20" y1="100" x2="180" y2="100" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 3" />
      <line x1="100" y1="38" x2="100" y2="162" stroke={STROKE} strokeWidth="0.8" strokeDasharray="2 3" />
      {/* Outer cardinal dots */}
      <circle cx="22" cy="100" r="3" fill={ACCENT} />
      <circle cx="178" cy="100" r="3" fill={ACCENT} />
      <circle cx="100" cy="42" r="3" fill={ACCENT} />
      <circle cx="100" cy="158" r="3" fill={ACCENT} />
      {/* Outer rectangle */}
      <rect x="74" y="80" width="52" height="40" stroke={STROKE} strokeWidth="1.5" />
      {/* Inner rectangle */}
      <rect x="84" y="88" width="32" height="24" stroke={STROKE} strokeWidth="1" />
      {/* Center dot */}
      <circle cx="100" cy="100" r="2.5" fill={ACCENT} />
    </svg>
  );
}

function LoadedLeader() {
  return (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Top circle */}
      <circle cx="100" cy="38" r="9" stroke={STROKE} strokeWidth="1.5" fill="#F2F1EE" />
      {/* Tier 1 (smallest) */}
      <rect x="80" y="52" width="40" height="20" stroke={STROKE} strokeWidth="1.5" fill="#EDEBE6" />
      {/* Tier 2 */}
      <rect x="68" y="74" width="64" height="22" stroke={STROKE} strokeWidth="1.5" fill="#E0DFDB" />
      {/* Tier 3 */}
      <rect x="56" y="98" width="88" height="24" stroke={STROKE} strokeWidth="1.5" fill="#D0CEC8" />
      {/* Orange band */}
      <rect x="48" y="124" width="104" height="14" fill={ACCENT} stroke={STROKE} strokeWidth="1.5" />
      {/* Black base */}
      <rect x="42" y="140" width="116" height="16" fill="#1A1A1A" stroke={STROKE} strokeWidth="1.5" />
      {/* Inward arrows — top arc */}
      <path d="M30 75 Q60 60 80 78" stroke={STROKE} strokeWidth="1" fill="none" strokeDasharray="2 2" />
      <path d="M170 75 Q140 60 120 78" stroke={STROKE} strokeWidth="1" fill="none" strokeDasharray="2 2" />
      {/* Side inward arrows */}
      <path d="M28 95 L52 95" stroke={STROKE} strokeWidth="1.5" />
      <path d="M44 90 L52 95 L44 100" stroke={STROKE} strokeWidth="1.5" fill="none" />
      <path d="M172 95 L148 95" stroke={STROKE} strokeWidth="1.5" />
      <path d="M156 90 L148 95 L156 100" stroke={STROKE} strokeWidth="1.5" fill="none" />
      <path d="M28 115 L48 115" stroke={STROKE} strokeWidth="1.5" />
      <path d="M40 110 L48 115 L40 120" stroke={STROKE} strokeWidth="1.5" fill="none" />
      <path d="M172 115 L152 115" stroke={STROKE} strokeWidth="1.5" />
      <path d="M160 110 L152 115 L160 120" stroke={STROKE} strokeWidth="1.5" fill="none" />
    </svg>
  );
}

function FracturedAchiever() {
  return (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Central scattered grid */}
      <rect x="78" y="60" width="22" height="22" stroke={STROKE} strokeWidth="1.3" />
      <rect x="100" y="60" width="22" height="22" stroke={STROKE} strokeWidth="1.3" />
      <rect x="78" y="82" width="22" height="22" stroke={STROKE} strokeWidth="1.3" />
      <rect x="100" y="82" width="22" height="22" stroke={STROKE} strokeWidth="1.3" />
      <rect x="78" y="104" width="22" height="22" stroke={STROKE} strokeWidth="1.3" />
      <rect x="100" y="104" width="22" height="22" stroke={STROKE} strokeWidth="1.3" />
      {/* Detached squares */}
      <rect x="48" y="30" width="14" height="14" stroke={STROKE} strokeWidth="1.2" transform="rotate(15 55 37)" />
      <rect x="148" y="38" width="12" height="12" stroke={STROKE} strokeWidth="1.2" transform="rotate(-10 154 44)" fill={ACCENT} />
      <rect x="40" y="142" width="14" height="14" stroke={STROKE} strokeWidth="1.2" transform="rotate(20 47 149)" />
      <rect x="150" y="148" width="12" height="12" stroke={STROKE} strokeWidth="1.2" transform="rotate(-15 156 154)" />
      <rect x="142" y="100" width="10" height="10" stroke={STROKE} strokeWidth="1.2" fill={ACCENT} />
      {/* Outward arrows (dashed) */}
      <line x1="100" y1="60" x2="100" y2="22" stroke={STROKE} strokeWidth="1" strokeDasharray="3 2" />
      <path d="M96 28 L100 22 L104 28" stroke={STROKE} strokeWidth="1" fill="none" />
      <line x1="100" y1="126" x2="100" y2="172" stroke={STROKE} strokeWidth="1" strokeDasharray="3 2" />
      <path d="M96 166 L100 172 L104 166" stroke={STROKE} strokeWidth="1" fill="none" />
      <line x1="78" y1="93" x2="30" y2="93" stroke={STROKE} strokeWidth="1" strokeDasharray="3 2" />
      <path d="M36 89 L30 93 L36 97" stroke={STROKE} strokeWidth="1" fill="none" />
      <line x1="122" y1="93" x2="172" y2="93" stroke={STROKE} strokeWidth="1" strokeDasharray="3 2" />
      <path d="M166 89 L172 93 L166 97" stroke={STROKE} strokeWidth="1" fill="none" />
      {/* Diagonal scatter dots */}
      <circle cx="62" cy="58" r="2" fill={ACCENT} />
      <circle cx="140" cy="68" r="2" fill={STROKE} />
      <circle cx="62" cy="138" r="2" fill={STROKE} />
      <circle cx="142" cy="130" r="2" fill={ACCENT} />
    </svg>
  );
}

function BoundarylessPerformer() {
  return (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Dashed broken rectangle */}
      <rect x="40" y="50" width="120" height="100" stroke={STROKE} strokeWidth="1.4" strokeDasharray="6 5" fill="none" />
      {/* Wavy lines flowing across */}
      <path d="M20 78 Q60 62 100 80 T180 78" stroke={STROKE} strokeWidth="1.4" fill="none" />
      <path d="M20 100 Q60 84 100 102 T180 100" stroke={STROKE} strokeWidth="1.4" fill="none" />
      <path d="M20 122 Q60 106 100 124 T180 122" stroke={STROKE} strokeWidth="1.4" fill="none" />
      {/* Leaking arrows */}
      <line x1="170" y1="80" x2="186" y2="74" stroke={STROKE} strokeWidth="1.2" />
      <path d="M180 72 L186 74 L182 80" stroke={STROKE} strokeWidth="1.2" fill="none" />
      <line x1="172" y1="124" x2="186" y2="132" stroke={STROKE} strokeWidth="1.2" />
      <path d="M180 134 L186 132 L182 126" stroke={STROKE} strokeWidth="1.2" fill="none" />
      <line x1="100" y1="150" x2="100" y2="168" stroke={STROKE} strokeWidth="1.2" />
      <path d="M96 162 L100 168 L104 162" stroke={STROKE} strokeWidth="1.2" fill="none" />
      {/* Orange dots scattered */}
      <circle cx="58" cy="78" r="3" fill={ACCENT} />
      <circle cx="138" cy="100" r="3" fill={ACCENT} />
      <circle cx="86" cy="122" r="2.5" fill={ACCENT} />
      <circle cx="156" cy="60" r="2" fill={ACCENT} />
      <circle cx="44" cy="140" r="2" fill={ACCENT} />
    </svg>
  );
}

function OverclockedExecutive() {
  return (
    <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {/* Outer dial circle */}
      <circle cx="100" cy="108" r="58" stroke={STROKE} strokeWidth="1.5" fill="none" />
      {/* Tick marks (12 around the top half) */}
      {Array.from({ length: 13 }).map((_, i) => {
        const angle = Math.PI + (Math.PI * i) / 12;
        const x1 = 100 + Math.cos(angle) * 52;
        const y1 = 108 + Math.sin(angle) * 52;
        const x2 = 100 + Math.cos(angle) * 58;
        const y2 = 108 + Math.sin(angle) * 58;
        return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} stroke={STROKE} strokeWidth="1" />;
      })}
      {/* Red zone arc (right side) */}
      <path d="M 100 50 A 58 58 0 0 1 158 108" stroke={ACCENT} strokeWidth="3" fill="none" opacity="0.85" />
      {/* Needle pointing into red zone (upper right) */}
      <line x1="100" y1="108" x2="142" y2="74" stroke={ACCENT} strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="100" cy="108" r="4" fill={STROKE} />
      {/* Microchip below */}
      <rect x="78" y="124" width="44" height="32" stroke={STROKE} strokeWidth="1.4" fill="#F2F1EE" />
      <rect x="86" y="132" width="28" height="16" stroke={STROKE} strokeWidth="1" />
      {/* Chip pins */}
      {[0, 1, 2, 3].map(i => (
        <line key={`l${i}`} x1="78" y1={130 + i * 6} x2="72" y2={130 + i * 6} stroke={STROKE} strokeWidth="1" />
      ))}
      {[0, 1, 2, 3].map(i => (
        <line key={`r${i}`} x1="122" y1={130 + i * 6} x2="128" y2={130 + i * 6} stroke={STROKE} strokeWidth="1" />
      ))}
      {/* Heat lines rising */}
      <path d="M82 36 Q86 28 82 22 Q78 16 82 10" stroke={ACCENT} strokeWidth="1.5" fill="none" />
      <path d="M100 32 Q104 24 100 18 Q96 12 100 6" stroke={ACCENT} strokeWidth="1.5" fill="none" />
      <path d="M118 36 Q122 28 118 22 Q114 16 118 10" stroke={ACCENT} strokeWidth="1.5" fill="none" />
    </svg>
  );
}

const REGISTRY = {
  'Grounded Operator': GroundedOperator,
  'Loaded Leader': LoadedLeader,
  'Fractured Achiever': FracturedAchiever,
  'Boundaryless Performer': BoundarylessPerformer,
  'Overclocked Executive': OverclockedExecutive,
};

export default function ArchetypeIcon({ name, size = 200 }) {
  const Icon = REGISTRY[name] || GroundedOperator;
  return (
    <div style={{ width: size, height: size, maxWidth: '100%' }}>
      <Icon />
    </div>
  );
}

export { GroundedOperator, LoadedLeader, FracturedAchiever, BoundarylessPerformer, OverclockedExecutive };
